import dayjs from "dayjs";
import { useEffect } from "react";
import { useState } from "react";
import Blank from "../../DefaultStyles/Blank";
import CouponSection from "./PromotionBoard/CouponSection";
import PointSection from "./PromotionBoard/PointSection";
import PointUsingSection from "./PromotionBoard/PointUsingSection";
import DashBoardDateFilter from "./DashBoardDateFilter";
import { DashBoardDateFilterContainer, DashBoardSection } from "./UserBoard";

export default function PromotionBoard() {
  const [filter, setFilter] = useState({
    startDate: dayjs().add(-7, "day")?.format("YYYY-MM-DD") ?? "",
    endDate: dayjs().add(-1, "day")?.format("YYYY-MM-DD") ?? "",
    isAccum: false,
  });

  const [secondFilter, setSecondFilter] = useState({
    startDate: "",
    endDate: "",
    isAccum: false,
  });

  const [thirdFilter, setThirdFilter] = useState({
    startDate: "",
    endDate: "",
    isAccum: false,
  });

  useEffect(() => {
    if (filter.endDate !== "") {
      setSecondFilter({
        ...secondFilter,
        startDate: filter.startDate,
        endDate: filter.endDate,
      });

      setThirdFilter({
        ...thirdFilter,
        startDate: filter.startDate,
        endDate: filter.endDate,
      });
    }
  }, [filter]);

  return (
    <DashBoardSection>
      <DashBoardDateFilterContainer>
        <DashBoardDateFilter
          setFilter={setFilter}
          filter={filter}
          isAfter={{ value: 2, unit: "week" }}
        />
      </DashBoardDateFilterContainer>

      {/* 쿠폰 등록 현황 */}
      <CouponSection setFilter={setFilter} filter={filter} />
      <Blank blankHeight={40} />

      {/* 포인트 등록 현황 */}
      <PointSection setFilter={setSecondFilter} filter={secondFilter} />
      <Blank blankHeight={40} />

      {/* 포인트 이용 현황 */}
      <PointUsingSection setFilter={setThirdFilter} filter={thirdFilter} />
    </DashBoardSection>
  );
}
